import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Helmet } from "react-helmet-async";
export function PageSEO({ title, description }) {
    const fullTitle = `${title} | PENA`;
    return (_jsxs(Helmet, { children: [_jsx("title", { children: fullTitle }), description && _jsx("meta", { name: "description", content: description })] }));
}
